import { Routes } from '@angular/router';
import { AuthGuard } from '@core/auth/guards/auth.guard';

export const KOPPEL_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./koppel-list/koppel-list.component').then(m => m.KoppelListComponent),
    canActivate: [AuthGuard],
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./koppel-detail/koppel-detail.component').then(m => m.KoppelDetailComponent),
    canActivate: [AuthGuard],
  }
];
